export function isObject(item) {
  return typeof item !== 'string';
}

export function isDeleted(item) {
  if (isObject(item) && item[0] !== undefined && item[1] === undefined && item[2] === undefined) {
    return true;
  } else {
    return false;
  }
}

export function isNew(item) {
  if (isObject(item) && item[0] !== undefined && item[1] === 0 && item[2] === 0) {
    return true;
  } else {
    return false;
  }
}

export function hasChanged(item) {
  if (isObject(item) && item !== undefined && !isDeleted(item) && !isNew(item)) {
    return true;
  } else {
    return false;
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/sql/diffUtils.js
 **/